import React from "react";
import { GET } from "lib/api";
import InputLabelDatePicker from "Components/Fragment/InputLabelDatePicker";
import PriorityDropdown from "lib/components/PriorityDropdown";
import Form from "lib/components/Form";
import { IconButton } from "lib/components/Button";
import { Button } from "Components/Base/Inputs/Button";
import { Grid } from "Components/Base/Layout/Grid";
import LuvitComponent from "LuvitComponent";
import PersonalGoalsDropdown from "lib/components/PersonalGoalsDropdown";
import config from "lib/config";
import dompurify from "dompurify";
import * as constants from "./constants";
import * as styles from "./styles";
import SettingStore from "stores/settings";
import format from "lib/format";
import ValidationSummary from "lib/components/ValidationSummary";

var filter = [0, 0, 0, 0, 0];

const MODAL_STEP_ADD = 0;
const MODAL_STEP_SUBMIT = 1;

const isTypeOnlineCourse = (selectedCourse) => {
  return selectedCourse?.type?.toLowerCase() === "online";
};

const isIdOnlineCourse = (selectedCourse) => {
  return selectedCourse?.courseId && !selectedCourse.courseUrl;
};

const hasActivityData = (activity) => {
  return (
    activity.hasOwnProperty("isLocked") &&
    activity.hasOwnProperty("status") &&
    activity.hasOwnProperty("isCompleted")
  );
};

const checkActivityWithDataAbleToRegister = (activity) => {
  return (
    activity.type === "onlinecourse" &&
    !activity.isLocked &&
    activity.status !== "registered" &&
    !activity.isCompleted
  );
};

const checkActivityNoDataAbleToRegister = async (
  selectedCourse,
  personalId,
) => {
  const paramID = selectedCourse?.value || selectedCourse?.courseId;
  const userCourseInfo = await getUserCourseInfo(paramID, personalId);
  return !userCourseInfo.completed && !userCourseInfo.registered;
};

const getUserCourseInfo = async (courseId, personalId) => {
  const userCourseData = await GET(
    "v1/user/:personalId/onlinecourseinfo/:courseId",
    {
      personalId: personalId,
      courseId: courseId,
    },
  );
  return userCourseData[0] || false;
};

export default class AddInternal extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "TalentManagement");
    this.toggleCourseDetails = this.toggleCourseDetails.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.updateParentBack = this.updateParentBack.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.sanitizer = dompurify.sanitize;
  }

  componentWillMount() {
    const activity = this.props.activity;
    const isBt = SettingStore.getSettingValue("bt") === "1";

    this.onRefresh();
    this.setState({
      signed: false,
      responsible: activity.responsible || this.props.personalName || "",
      priority: activity.priority,
      goal: activity.personalGoalId || activity.goalId,
      comment: activity.comments,
      deadlineDate: activity.dueDate || activity.deadlineDate || "",
      isBt: isBt || false,
      personalPlannedCourseId: undefined,
    });
    this.checkIfAbleToRegister(activity, null, this.props.personalId);
  }

  checkIfAbleToRegister = (activity, selectedActivityFromList, personalId) => {
    if (Object.keys(activity || {}).length > 0) {
      if (hasActivityData(activity)) {
        // Klickat på en existerande läraktivitet via utvecklingsplan
        const isAbleToRegister = checkActivityWithDataAbleToRegister(activity);
        this.setState({ ableToRegister: isAbleToRegister });
      } else if (isIdOnlineCourse(activity)) {
        // Klickat på en existerande rekommenderad läraktivitet via kompetensprofil
        checkActivityNoDataAbleToRegister(activity, personalId).then(
          (isAbleToRegister) =>
            this.setState({ ableToRegister: isAbleToRegister }),
        );
      }
    }
    if (Object.keys(selectedActivityFromList || {}).length > 0) {
      // Lägger till en ny läraktivitet via listan i modalen "lägg till aktivitet"
      if (isTypeOnlineCourse(selectedActivityFromList)) {
        checkActivityNoDataAbleToRegister(
          selectedActivityFromList,
          personalId,
        ).then((isAbleToRegister) =>
          this.setState({ ableToRegister: isAbleToRegister }),
        );
      } else {
        this.setState({ ableToRegister: false });
      }
    }
  };

  async onRefresh() {
    let results = await GET(
      `/v1/coursecatalogue?${new URLSearchParams({
        personalId: this.props.personalId,
        portalSiteId: config.siteId,
      })}&${filter.map((category) => "categories=" + category).join("&")}`,
    );
    let categories = await GET(`/v1/coursecataloguecategories/:portalSiteId/`, {
      portalSiteId: config.siteId,
    });

    let courses = results.map((c) => {
      return {
        label: c.title,
        description: c.description,
        type: c.type,
        value: c.type.toLowerCase() == "online" ? c.courseId : c.courseObjectId,
      };
    });
    this.setState({
      ready: true,
      courses,
      categories: categories,
      errors: [],
    });
  }

  renderOption(option) {
    let style = { cursor: "pointer" };
    const { selectedCourse } = this.state;

    if (selectedCourse == option) {
      style.backgroundColor = "rgba(100,155,255,0.1)";
    }

    return (
      <div
        key={option.value}
        className="activity-select"
        onClick={this.selectCourse(option)}
        style={style}
        ref={"option-" + option.value}
      >
        <input
          type="radio"
          id={`radio-option-${option.value}`}
          checked={selectedCourse == option}
          style={{ cursor: "pointer" }}
          className="markActivity"
        />
        <h3>
          <strong>
            <label htmlFor={`radio-option-${option.value}`}>
              {option.label}
            </label>
          </strong>
        </h3>
        <div className="flex flex-space-b ">
          <div className="activity-select-type">
            {this.GetOptionTypeTranslation(option)}
          </div>
          <button
            type="button"
            role="button"
            className="button-secondary"
            onClick={this.viewCourseDetails.bind(this, option)}
          >
            {this.l("readmore")}
          </button>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: this.sanitizer(option.description),
          }}
        />
      </div>
    );
  }

  GetOptionTypeTranslation(option) {
    if (option) {
      switch (option.type.toLowerCase()) {
        case "classroom":
          return this.l("instructorledtraining");
        case "online":
          return this.l("onlinecoursetype");
        default:
          return this.l(option.type);
      }
    }
  }

  activityInvalid(activity, selectedCourse) {
    let errors = [];
    if (!activity.id && selectedCourse.value === "") {
      errors.push({ msg: this.l("errEnterTitle"), cssClass: "error2" });
    }
    if (!this.state.deadlineDate || !this.state.deadlineDate === "") {
      errors.push({ msg: this.l("enterExpiredate"), cssClass: "error2" });
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return true;
    }
    return false;
  }

  async SaveActivity(registration) {
    const { activity, personalId } = this.props;
    const { selectedCourse } = this.state;

    if (this.activityInvalid(activity, selectedCourse)) {
      return;
    }

    const { courseObjectId, courseId, title } = this.getCourseInfo(
      activity,
      selectedCourse,
    );
    const { goal, personalPlannedCourseId, deadlineDate } = this.state;
    const { TxtComment, SelPrio, TxtDescription, TxtResponsible } = this.refs;

    let data = {
      deadlineDate: deadlineDate,
      personalId,
      compTalkID: null,
      courseObjectId,
      title,
      comments: TxtComment.value || "-",
      isCompleted: false,
      createdBy: personalId,
      period: "-",
      priority: SelPrio ? SelPrio.state.currentValue : null,
      description: TxtDescription.innerHTML,
      showComment: false,
      endDate: null,
      isOtherTraining: false,
      courseId,
      personalGoalId: goal,
      responsible: TxtResponsible ? TxtResponsible.value : null,
      personalPlannedCourseId,
    };

    this.props.save(data, [], registration).then((response) => {
      if (response > 0) {
        this.setState({ personalPlannedCourseId: response });
      }
      this.toggleCourseDetails();
    });
  }

  getCourseInfo(activity, selectedCourse) {
    let courseInfo = { courseId: null, courseObjectId: null, title: "" };
    if (!activity.id) {
      if (selectedCourse.value) {
        if (selectedCourse.type.toLowerCase() === "online") {
          courseInfo.courseId = selectedCourse.value;
        } else {
          courseInfo.courseObjectId = selectedCourse.value;
        }
        courseInfo.title = selectedCourse.label;
      }
    } else {
      courseInfo.courseId = activity.courseId;
      courseInfo.courseObjectId = activity.courseObjectId;
      courseInfo.title = activity.title;
    }

    return courseInfo;
  }

  viewCourseDetails(course, fromCourseList) {
    const { selectedCourse, selectedCourseId, courseDetails } = this.state;

    let additionalCourseData = {};
    if (!courseDetails) {
      if (course.type === undefined && selectedCourse !== undefined) {
        additionalCourseData = selectedCourse;
      }
      this.setState({ openCourse: { ...course, ...additionalCourseData } });
    } else {
      this.setState({ openCourse: null });
    }

    if (fromCourseList) {
      this.setState({ courseDetails: !courseDetails });
    }

    if (selectedCourseId) {
      setTimeout(
        (() => {
          this.refs["option-" + selectedCourse.value] &&
            this.refs["option-" + selectedCourse.value].scrollIntoView();
        }).bind(this),
        10,
      );
    }
    this.updateParentBack();
  }

  selectCourse(course) {
    return (() => {
      var description = course.description;
      this.setState({
        description: description,
        selectedCourse: course,
        selectedCourseId: course.value,
      });
      this.checkIfAbleToRegister(null, course, this.props.personalId);
    }).bind(this);
  }

  renderCategories() {
    var self = this;
    var count = -1;
    var categories = this.state.categories.map(function (c) {
      count++;
      var order = count;
      return (
        <div key={c.categoryId} className="flex-1">
          <select
            name=""
            className="flex-1"
            data-id={c.categoryId}
            onChange={(e) => self.updateFilter(e, order)}
          >
            <option value="0">-- {self.l(c.title)} --</option>
            {self.renderCategoryValues(c.values)}
          </select>{" "}
          &nbsp;
        </div>
      );
    });

    return categories;
  }

  renderCategoryValues(values) {
    return values.map(function (v) {
      return (
        <option key={v.valueId} value={v.valueId}>
          {v.title}
        </option>
      );
    });
  }

  updateFilter(e, count) {
    filter[count] = e.target.value;
    this.setState({ filter });
    this.onRefresh();
  }

  toggleCourseDetails() {
    let act = this.props.activity;
    this.viewCourseDetails(act, true);
  }

  updateParentBack() {
    setTimeout(
      (() => {
        const { courseDetails, openCourse, activeView } = this.state;
        this.props.hideBack(
          !!(
            courseDetails ||
            openCourse ||
            (!this.props.activity.id && activeView > MODAL_STEP_ADD)
          ),
        );
      }).bind(this),
      10,
    );
  }

  setActiveView(newView) {
    return (() => {
      this.setState({ activeView: newView });

      this.updateParentBack();
    }).bind(this);
  }

  updateSearch() {
    let searchVal = this.refs.searchField.value.toLowerCase();
    let newState = { searchVal };

    if (
      this.state.selectedCourse &&
      this.state.selectedCourse.label.toLowerCase().indexOf(searchVal) < 0
    )
      newState = { searchVal, selectedCourse: null, selectedCourseId: null };

    this.setState(newState);
  }

  changePriority(p) {
    this.setState({ priority: p });
  }

  changeGoal(g) {
    this.setState({ goal: g });
  }

  doRender() {
    if (!this.state || !this.state.ready) return <div />;
    let path = document.location.pathname;
    path.indexOf("/talentmanagement/") > -1 &&
      (path = path.substr(0, path.indexOf("talentmanagement/")));

    const { courseDetails, openCourse, ableToRegister } = this.state;
    const { personalId, isManager, activity } = this.props;

    if (courseDetails && openCourse) {
      let url = path;
      if (openCourse.type) {
        const isOnlineCourse =
          openCourse.type.toLowerCase() == "online" ||
          openCourse.courseId ||
          openCourse.courseID;
        if (isOnlineCourse) {
          let courseId = openCourse.courseId;
          if (!courseId) courseId = openCourse.courseID;

          if (!courseId) courseId = openCourse.value;

          url +=
            "Activities/OnlineCourseDetails.aspx?personalid=" +
            personalId +
            "&ismanager=" +
            isManager +
            "&m=true&courseid=" +
            courseId;
        } else {
          let courseObjectId = openCourse.courseObjectId;
          if (!courseObjectId) courseObjectId = openCourse.courseObjectID;

          if (!courseObjectId) courseObjectId = openCourse.value;

          url +=
            "Activities/ActivityDetails.aspx?id=" +
            courseObjectId +
            "&pid=" +
            personalId +
            "&ismanager=" +
            isManager +
            "&from=cpl&m=1";
        }
      }

      let src = url;

      return (
        <div className="animated fadeInLeft">
          <div className="flex flex-end">
            <button
              onClick={this.toggleCourseDetails}
              className="button-transparent button-singleadd"
            >
              {this.l("back")}
            </button>
          </div>

          <iframe
            title={this.l("courseDetails")}
            style={{ minHeight: "525px", minWidth: "800px" }}
            src={src}
          />
        </div>
      );
    }
    const title = activity?.title ?? activity.courseTitle;

    let mobileViewport =
      window.matchMedia("(max-width: 400px)").matches || false;
    let courseListStyle = mobileViewport
      ? {}
      : { maxHeight: "455px", overflow: "auto" };
    const activityURL = activity.munioURL
      ? activity.munioURL
      : format.url("/education/entercourse.aspx?courseid=" + activity.courseId);

    const displayActivityLinks =
      (activity.courseObjectId ||
        activity.courseObjectID ||
        activity.courseId ||
        activity.courseID) &&
      !activity.isLocked;

    return (
      <Form onSubmit={() => this.SaveActivity(false)}>
        {this.state.errors.length > 0 && (
          <ValidationSummary errors={this.state.errors} />
        )}
        {displayActivityLinks && (
          <span style={{ float: "right" }}>
            <button onClick={this.toggleCourseDetails}>
              {this.l(
                activity.courseId
                  ? "courseInformationRegistration"
                  : "courseinfo",
              )}
            </button>

            {activity.type === constants.ACTIVITY_TYPE_ONLINECOURSE &&
              activity.hasAccessToOnlineCourse &&
              !isManager && (
                <a
                  href={activityURL}
                  {...(activity.munioURL && { target: "_blank" })}
                  title={this.l("entercoursesession")}
                >
                  {this.l("entercoursesession")}
                </a>
              )}
          </span>
        )}

        <div>
          {!activity.id && !this.state.activeView && (
            <div style={{ minHeight: "300px" }}>
              <div className="input-search">
                <input
                  type="text"
                  className="input"
                  placeholder={this.l("searchcourse")}
                  aria-label={this.l("searchcourse")}
                  id="searchField"
                  ref="searchField"
                  onKeyUp={this.updateSearch}
                  defaultValue={this.state.searchVal}
                />
                <IconButton
                  icon="icon-search"
                  label={this.l("search")}
                  onClick={() => document.getElementById("searchField").focus()}
                />
              </div>
              <br />
              <br />

              <div style={courseListStyle}>
                {this.state.courses
                  .filter(
                    (c) =>
                      c.label
                        .toLowerCase()
                        .indexOf(this.state.searchVal || "") >= 0,
                  )
                  .map((c) => this.renderOption(c))}
              </div>
              <div>
                <br />
                <div className="flex flex-end">
                  {!this.state.selectedCourseId && (
                    <div className="italic" style={{ padding: "10px" }}>
                      {this.l("chooseCourseToContinue")}
                    </div>
                  )}
                  <button
                    type="button"
                    role="button"
                    className="button-cta"
                    disabled={!this.state.selectedCourseId}
                    onClick={this.setActiveView(1)}
                  >
                    {this.l("Continue")}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {(activity.id || this.state.activeView > MODAL_STEP_ADD) && (
          <div>
            {!activity.id && (
              <div className="flex flex-end">
                <Button
                  variant="text"
                  onClick={this.setActiveView(MODAL_STEP_ADD)}
                >
                  {this.l("back")}
                </Button>
              </div>
            )}
            <label>{this.l("title")}:</label>
            {activity.id ? (
              <div>{title}</div>
            ) : (
              <div>{this.state.selectedCourse.label}</div>
            )}
            <br />
            <div>
              <label>{this.l("description")}:</label>
              <div
                className="goal-addactivity-internal-description"
                ref="TxtDescription"
                style={{ maxWidth: "680px" }}
                dangerouslySetInnerHTML={{
                  __html: this.sanitizer(
                    activity.id ? activity.description : this.state.description,
                  ),
                }}
              />
            </div>
            <br />
            <div className="flex flex-wrap">
              {!this.state.isBt && (
                <div style={{ marginRight: "20px" }}>
                  <label htmlFor="addactivity-priority">
                    {this.l("priority")}:
                  </label>
                  <PriorityDropdown
                    id="addactivity-priority"
                    defaultValue={this.state.priority}
                    ref="SelPrio"
                    updateParentState={this.changePriority.bind(this)}
                  />
                </div>
              )}
              &nbsp;
              <div>
                <InputLabelDatePicker
                  id="CalDate"
                  label={this.l("expiredate")}
                  name={this.l("expiredate")}
                  value={this.state.deadlineDate}
                  onChange={(event) =>
                    this.setState({ deadlineDate: event.target.value })
                  }
                  placeholder={
                    this.state.errors && this.state.errors.CalDate
                      ? this.state.errors.CalDate.msg
                      : null
                  }
                  oldStyleLabel={true}
                  required
                />
              </div>
            </div>
            {activity.formalCompetencies && this.state.isBt && (
              <div>
                <br />
                <div>
                  {
                    <div>
                      <label>
                        {this.state.isBt
                          ? this.l("subgoals")
                          : this.l("formalCompetencies") + ":"}
                      </label>
                      <styles.StyledFormalCompetenceList>
                        {activity.formalCompetencies &&
                          activity.formalCompetencies
                            .split(constants.DEVELOPMENT_PLAN_FILTER_SPLIT)
                            .map((formalComptence) => (
                              <li>{formalComptence}</li>
                            ))}
                      </styles.StyledFormalCompetenceList>
                    </div>
                  }
                </div>
              </div>
            )}
            <div>
              <label htmlFor="SelPersonalGoal">
                {this.state.isBt ? this.l("program") : this.l("connecttogoal")}:
              </label>
              <PersonalGoalsDropdown
                ref="SelPersonalGoal"
                id="SelPersonalGoal"
                personalId={personalId}
                updateParentState={this.changeGoal.bind(this)}
                defaultValue={this.state.goal}
              />
            </div>
            {!this.state.isBt && (
              <div>
                <label htmlFor="TxtResponsible">
                  {this.l("responsible1")}:
                </label>
                <input
                  className="input"
                  type="text"
                  id="TxtResponsible"
                  ref="TxtResponsible"
                  value={this.state.responsible}
                  onChange={(e) =>
                    this.setState({ responsible: e.target.value })
                  }
                />
              </div>
            )}
            {activity.formalCompetencies && !this.state.isBt && (
              <div>
                <label>
                  {this.state.isBt
                    ? this.l("subgoals")
                    : this.l("formalCompetencies") + ":"}
                </label>
                <styles.StyledFormalCompetenceList>
                  {activity.formalCompetencies &&
                    activity.formalCompetencies
                      .split(constants.DEVELOPMENT_PLAN_FILTER_SPLIT)
                      .map((formalComptence) => <li>{formalComptence}</li>)}
                </styles.StyledFormalCompetenceList>
              </div>
            )}
            <div>
              <label htmlFor="TxtComment">{this.l("comment")}:</label>
              <textarea
                ref="TxtComment"
                id="TxtComment"
                className="input"
                value={this.state.comment}
                onChange={(e) => this.setState({ comment: e.target.value })}
              />
            </div>
            <Grid container spacing={1} justifyContent="flex-end">
              {ableToRegister && (
                <Grid item>
                  <Button
                    onClick={() => this.SaveActivity(true)}
                    label={this.l("saveandregister")}
                  />
                </Grid>
              )}
              {!activity.isLocked && (
                <Grid item>
                  <Button type="submit" label={this.l("save")} />
                </Grid>
              )}
              <Grid item>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={this.props.onCancel}
                  label={this.l("cancel")}
                />
              </Grid>
            </Grid>
          </div>
        )}
      </Form>
    );
  }
}
